define(
({
  "select_shipping_method": "Seleccionar método de envío"
})
);
